import { chain } from 'lodash';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn'
import relativeTime from 'dayjs/plugin/relativeTime'
import constant from '../../constant';
import request from '../../../utils/request';
import { GET_HOT_COMMENT } from '../../../urls'
import { showTip } from '../../../utils'

dayjs.locale('zh-cn')
dayjs.extend(relativeTime)

const convertComment = ({ time, ...rest }) => {
  const timestamp = Math.round(time / 1000); // 转换成毫秒

  const timeObj = dayjs(timestamp);

  const result = {
    timestamp,
    datetime: timeObj.format(),
    time: timeObj.fromNow(),
    ...rest,
  };

  return result
}

const getHotComment = (params = {}) => {
  return async (dispatch) => {

    try {
      const sDocId = params.sDocId
      if (sDocId) {
        const sUserId = params.sUserId

        const res = await request.get(GET_HOT_COMMENT, {
          sDocId,
          sUserId
        })

        if (res.code === 0) {
          let comments = res.data.comments || []
          const commentNumber = res.data.commentNumber

          comments = chain(comments)
            .map(convertComment)
            .value()
          dispatch(getHotCommentSuccess({
            hotList: comments,
            number: commentNumber
          }))

          return comments
        }
      } else {
        console.log('missed shSid')
      }

    } catch (error) {
      console.log('getHotComment error',error)
      showTip(error.msg || '服务异常，请稍后再试')
    }
  }
}


const getHotCommentSuccess = (comment) => {
  return {
    type: constant.COMMENT.GET_HOT_COMMENT,
    comment
  }
}

export default {
  getHotCommentSuccess,
  getHotComment
}